/**
 * Column definitions for access contact tables (sector admin vs plant user access manager).
 */
import EmailIcon from "@mui/icons-material/Email";
import FactoryIcon from "@mui/icons-material/Factory";
import PersonIcon from "@mui/icons-material/Person";
import { Box } from "@mui/material";
import { UseMaterialColors } from "lib/hooks";
import * as table from "lib/table";
import {
	PlantUserAccessManagerContact,
	SectorAdminContact,
} from "models/dto/user";

/** Head row for sector admin contact table (name, email). */
export function CreateHeadCells(
	materialColors: ReturnType<typeof UseMaterialColors>,
	onSort?: (property: string) => void
) {
	return table.CreateHeadCells<
		SectorAdminContact,
		unknown,
		keyof SectorAdminContact,
		string
	>(
		[
			{
				id: "name",
				numeric: false,
				width: 45,
				label: (
					<Box display="flex" alignItems="center" gap={0.5}>
						<PersonIcon
							sx={{ fontSize: 18, color: materialColors.primary }}
						/>
						<span>Name</span>
					</Box>
				) as any,
			},
			{
				id: "email",
				numeric: false,
				width: 55,
				label: (
					<Box display="flex" alignItems="center" gap={0.5}>
						<EmailIcon
							sx={{ fontSize: 18, color: materialColors.primary }}
						/>
						<span>Email</span>
					</Box>
				) as any,
			},
		],
		onSort || (() => undefined)
	);
}

/** Head row for plant user access manager table (adds plants column). */
export function CreatePlantUserHeadCells(
	materialColors: ReturnType<typeof UseMaterialColors>,
	onSort?: (property: string) => void
) {
	return table.CreateHeadCells<
		PlantUserAccessManagerContact,
		unknown,
		keyof PlantUserAccessManagerContact,
		string
	>(
		[
			{
				id: "name",
				numeric: false,
				width: 30,
				label: (
					<Box display="flex" alignItems="center" gap={0.5}>
						<PersonIcon
							sx={{ fontSize: 18, color: materialColors.primary }}
						/>
						<span>Name</span>
					</Box>
				) as any,
			},
			{
				id: "plants",
				numeric: false,
				width: 40,
				label: (
					<Box display="flex" alignItems="center" gap={0.5}>
						<FactoryIcon
							sx={{ fontSize: 18, color: materialColors.primary }}
						/>
						<span>Plants</span>
					</Box>
				) as any,
			},
			{
				id: "email",
				numeric: false,
				width: 30,
				label: (
					<Box display="flex" alignItems="center" gap={0.5}>
						<EmailIcon
							sx={{ fontSize: 18, color: materialColors.primary }}
						/>
						<span>Email</span>
					</Box>
				) as any,
			},
		],
		onSort || (() => undefined)
	);
}
